import { trackEventHarmonized } from '@/helpers/GTM/GTMTrack';
import { TrackingData } from '@/types';

export enum GTMAction {
  OPEN_DETAILS = 'openDetails',
  DISPLAY_OFFERS = 'displayOffers',
  USE_SLIDER = 'useSlider',
  OPEN_TOOLTIP = 'openTooltip',
  RUN_MORTGAGE_CALCULATOR = 'runMortgageCalculator',
  MORTGAGE_RESULTS = 'mortgageResults',
  GO_TO_MORTGAGE_OFFERS = 'goToMortgageOffers',
  REQUEST_MORTGAGE_CONSULTANT = 'requestMortgageConsultant',
  MORTGAGE_OFFERS = 'mortgage_offers',
  MORTGAGE_OFFERS_AND_CONSULTATION = 'mortgage_offers_and_consultation',
}

export enum GTMInteraction {
  PDP_INTERACTION = 'pdp_interaction',
  PARTNER_LINK_CLICK = 'partner_link_click',
  FEATURE_DISPLAYED = 'feature_displayed',
}

export enum GTMLabel {
  MORTGAGE_COMPARISON = 'mortgageComparison',
  HOUSEHOLD_INCOME = 'householdIncome',
  EQUITY_CAPITAL = 'equityCapital',
  EQUITY = 'equity',
  LOW_INCOME_AND_EQUITY = 'lowIncomeAndEquity',
  LOW_EQUITY = 'lowEquity',
  LOW_INCOME = 'lowIncome',
  AFFORDABLE = 'affordable',
  AFFORDABILITY_RESULT = 'affordability_result',
  EQUITY_RESULT = 'equity_result',
  MONTHLY_COSTS = 'mortgageCalculator_monthlyCosts',
  INTEREST_RATE = 'mortgageCalculator_interestRate',
}

// TODO: Consider removing eventName and pass the eventInteraction value in it's place
export function trackMortgageCalculatorEvent(
  eventName: string,
  { eventInteraction, eventAction, eventLabel, nonInteraction = false, targetUrl }: TrackingData,
): void {
  const dataObj = {
    h_event_category_006: eventInteraction,
    h_event_action_007: eventAction,
    h_event_label_008: eventLabel,
    non_interaction: nonInteraction,
    h_target_url_029: targetUrl,
  };

  trackEventHarmonized(eventName, dataObj);
}
